import React, { useEffect }  from 'react';
import { withStyles } from '@material-ui/core/styles';
import ChatUserTable from './ChatUserTable';
import ChatUserSearch from './ChatUserSearch';
import CSVButton from './ChatUserCSVButton';
import Pagination from '@material-ui/lab/Pagination';
import { Grid } from '@material-ui/core';

const styles = () => ({
    paper: {
        width: '95%',
        margin: '5px 5px 5px 50px',
    },
    paging: {
        marginTop: '20px',
        marginBottom: '20px'
    },
    csvButton:{
        justifyContent:'right',
        alignItems:'right',
        marginTop:'20px',
        display:'flex',
        marginRight:'100px'
    }
});

const displayNum = 50; //1ページあたりの項目数

function ChatUser (props) {
    const { classes, userData, setUserData, selectedKubunId, setSelectedKubunId, setSelectedKubunName } = props;
    const [page, setPage] = React.useState(1); //ページ番号
    const [pageCount, setPageCount] = React.useState(); //ページ数
    const [allItems, setAllItems] = React.useState([]); //全データ
    const [displayedItems, setDisplayedItems] = React.useState([]); //表示データ
    const [allUpdate, setAllUpdate] = React.useState(true);
    //スピナー表示用
    const [isLoading, setIsLoading] = React.useState(false);

    useEffect(() => {
        //検索時は1ページ目に戻る
        setPage(1);
        setAllItems(userData);
        //ページカウントの計算
        setPageCount(Math.ceil(userData.length / displayNum));
        //表示データを抽出
        setDisplayedItems(userData.slice(0, displayNum));
        //if(userData.length === 0 ) setAllUpdate(true);
    }, [userData]);

    const handleChange = (_event, index) => {
        //ページ移動時にページ番号を更新
        setPage(index);
        //ページ移動時に表示データを書き換える
        setDisplayedItems(allItems.slice(((index - 1) * displayNum), index * displayNum));
    };

    return (
        <React.Fragment>
            <div elevation={3} className={classes.paper} >
                <ChatUserSearch
                    setData={setUserData}
                    setAllUpdate={setAllUpdate}
                    setIsLoading={setIsLoading}
                    selectedKubunId={selectedKubunId}
                    setSelectedKubunId={setSelectedKubunId}
                    setSelectedKubunName={setSelectedKubunName}
                />
                {allItems.length > 0 && !isLoading && (
                    <CSVButton allData={allItems}/>
                )}
                <ChatUserTable
                    datas={displayedItems}
                    allData={allItems}
                    setData={setUserData}
                    allUpdate={allUpdate}
                    setAllUpdate={setAllUpdate}
                    isLoading={isLoading}
                />
                <Grid container item justifyContent ="center" alignItems="center" className={classes.paging}>
                    <Pagination count={pageCount} page={page} size="large" color="primary" onChange={handleChange} />
                </Grid>
            </div>
        </React.Fragment>
    );
};


export default withStyles(styles)(ChatUser);